import React, { useState, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion'; 
import { Helmet } from 'react-helmet-async';

// --- 1. Types and Data Definition ---

type CourseType = 'Course';

type Category = 
  | 'Web Development' 
  | 'App Development' 
  | 'Software Testing' 
  | 'Cloud & DevOps';

interface Course {
  image: string;
  logo: string;
  title: string;
  institution: string;
  type: CourseType;
  cardColor: string;
  category: Category;
  courseCount: number;
  href: string;
}

const allCourses: Course[] = [
  // ================= WEB DEVELOPMENT =================
  {
    image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'Java Full Stack', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'Web Development', courseCount: 12, href: '/java-full-stack'
  },
  {
    image: 'https://images.unsplash.com/photo-1526379095098-d400fd0bf935?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'Python Full Stack', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'Web Development', courseCount: 10, href: '/python-full-stack'
  },
  {
    image: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'Mern Full Stack', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'Web Development', courseCount: 8, href: '/mern-full-stack'
  },
  {
    image: 'https://images.unsplash.com/photo-1596558450268-9c27524ba856?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'Angular Full Stack', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'Web Development', courseCount: 6, href: '/angular'
  },
  {
    image: 'https://images.unsplash.com/photo-1629904853716-f004c377dd52?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'Backend Development', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'Web Development', courseCount: 5, href: '/backend-developer'
  },
  {
    image: 'https://images.unsplash.com/photo-1593720213428-28a5b9e94613?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'Frontend Development', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'Web Development', courseCount: 7, href: '/frontend-developer'
  },
  {
    image: 'https://images.unsplash.com/photo-1581276879432-15e50529f34b?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'ReactJS Development', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'Web Development', courseCount: 4, href: '/react-js'
  },
  {
    image: 'https://images.unsplash.com/photo-1614850523459-c2f4c699c52e?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'Wordpress Development', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'Web Development', courseCount: 3, href: '/wordpress'
  },

  // ================= APP DEVELOPMENT =================
  {
    image: 'https://images.unsplash.com/photo-1607252650355-f7fd0460ccdb?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'Android App Development', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'App Development', courseCount: 8, href: '/android'
  },
  {
    image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'iOS App Development', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'App Development', courseCount: 6, href: '/ios'
  },
  {
    image: 'https://images.unsplash.com/photo-1617042375876-a72e36732f04?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'Flutter Development', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'App Development', courseCount: 5, href: '/flutter'
  },
  {
    image: 'https://images.unsplash.com/photo-1551650975-87deedd944c3?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'React Native', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'App Development', courseCount: 4, href: '/react-native'
  },

  // ================= SOFTWARE TESTING =================
  {
    image: 'https://images.unsplash.com/photo-1516116216624-53e697fedbea?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'Manual Testing', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'Software Testing', courseCount: 4, href: '/software-eng/testing'
  },
  {
    image: 'https://images.unsplash.com/photo-1580894732444-8ecded7900cd?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'Automation Testing', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'Software Testing', courseCount: 6, href: '/software-eng/selenium'
  },
  {
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'Performance Testing', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'Software Testing', courseCount: 3, href: '/software-eng/fullstack'
  },
  {
    image: 'https://images.unsplash.com/photo-1526498460520-4c246339dccb?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'Mobile App Testing', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'Software Testing', courseCount: 3, href: '/software-eng/mobile-app'
  },
  {
    image: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'API Testing', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'Software Testing', courseCount: 4, href: '/api-testing'
  },

  // ================= CLOUD & DEVOPS =================
  {
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'AWS (Amazon Web Services)', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'Cloud & DevOps', courseCount: 10, href: '/cloud-devops/aws'
  },
  {
    image: 'https://images.unsplash.com/photo-1667372393119-c85c020799a3?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'Microsoft Azure', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'Cloud & DevOps', courseCount: 8, href: '/cloud-devops/azure'
  },
  {
    image: 'https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'Google Cloud Platform (GCP)', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'Cloud & DevOps', courseCount: 6, href: '/cloud-devops/gcp'
  },
  {
    image: 'https://images.unsplash.com/photo-1607799275518-d750cc061347?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'DevOps (CI/CD Pipeline)', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'Cloud & DevOps', courseCount: 8, href: '/cloud-devops/devops'
  },
  {
    image: 'https://images.unsplash.com/photo-1605745341112-85968b19335b?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'Docker & Kubernetes', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'Cloud & DevOps', courseCount: 5, href: '/cloud-devops/docker-kubernetes'
  },
  {
    image: 'https://images.unsplash.com/photo-1629654297299-c8506221ca97?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'Linux Administration', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'Cloud & DevOps', courseCount: 4, href: '/cloud-devops/linux'
  },
  {
    image: 'https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?auto=format&fit=crop&w=500&q=60',
    logo: '', title: 'Cloud Security Basics', institution: 'PIT', type: 'Course', cardColor: 'bg-gray-800 text-white', category: 'Cloud & DevOps', courseCount: 3, href: '/cloud-devops/cloud-security'
  }
];

const categories: Category[] = ['Web Development', 'App Development', 'Software Testing', 'Cloud & DevOps'];

// --- SEO Schema for Course Catalog ---
const catalogSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  "itemListElement": allCourses.map((course, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "url": `https://projectinfotech.in${course.href}`,
    "name": course.title
  }))
};

// --- 2. Course Card Component ---

const CourseCard: React.FC<Course> = ({ image, title, cardColor, courseCount, category, href }) => {
  return (
    <a href={href} className="block h-full" title={`Enroll in ${title} Training Course`}>
      <div className={`rounded-xl overflow-hidden shadow-2xl transition-all duration-300 hover:scale-[1.03] ${cardColor} flex flex-col h-full group cursor-pointer border border-gray-700/50`}>
        <div className="relative h-28 sm:h-48 overflow-hidden">
          <img src={image} alt={`${title} - ${category} Training Module`} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
          <div className="absolute inset-0 bg-black/40"></div>
          <span className="absolute top-2 right-2 bg-red-600 text-white text-[8px] sm:text-[10px] font-black px-2 py-0.5 rounded shadow-lg uppercase">
            {category.split(' ')[0]}
          </span>
        </div>
        <div className="p-3 sm:p-5 flex flex-col flex-grow">
          <h3 className="text-xs sm:text-lg font-bold mb-1 leading-tight text-white line-clamp-2 min-h-[2rem] sm:min-h-[3rem]">
            {title}
          </h3>
          <p className="text-[9px] sm:text-xs text-gray-400 mb-3">Professional Training</p>
          <div className="flex justify-between items-center pt-2 border-t border-gray-700/50 mt-auto">
            <span className="bg-blue-600 text-white text-[8px] sm:text-[10px] px-1.5 py-0.5 rounded font-black uppercase">COURSE</span>
            <span className="text-[8px] sm:text-xs text-gray-300 font-bold uppercase">{courseCount} Mods</span>
          </div>
        </div>
      </div>
    </a>
  );
};

// --- 3. Main ExploreCourses Component ---

const ExploreCourses: React.FC = () => {
    const [activeCategory, setActiveCategory] = useState<Category>('Web Development');
    const filteredCourses = useMemo(() => allCourses.filter(course => course.category === activeCategory), [activeCategory]);

  return (
    <div className="bg-gray-900 py-10 sm:py-20" id="explore-courses">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(catalogSchema)}</script>
      </Helmet>

      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-5xl font-black mb-3 text-white tracking-tight">Explore Top <span className="text-red-600">Courses</span></h2>
            <div className="h-1 w-20 bg-red-600 mx-auto rounded-full"></div>
        </div>

        {/* Category Buttons: Horizontal Scroll on Mobile */}
        <div className="flex overflow-x-auto sm:flex-wrap sm:justify-center gap-2 pb-4 mb-8 no-scrollbar" role="tablist">
          {categories.map((category) => (
            <button
              key={category}
              role="tab"
              aria-selected={activeCategory === category}
              onClick={() => setActiveCategory(category)}
              className={`whitespace-nowrap py-2 px-5 rounded-full font-bold transition-all text-[10px] sm:text-sm border ${
                activeCategory === category ? 'bg-red-600 border-red-600 text-white' : 'bg-gray-800 border-gray-700 text-gray-400'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        <div className="min-h-[400px]"> 
            <AnimatePresence mode="wait">
                <motion.div 
                    key={activeCategory} 
                    initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}
                    className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-6"
                    role="tabpanel"
                >
                    {filteredCourses.map((course) => (
                        <CourseCard key={course.title} {...course} />
                    ))}
                </motion.div>
            </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default ExploreCourses;